<iframe #frame title="Acompanhamento Seller" src="https://app.powerbi.com/view?r=eyJrIjoiNGZjM2ZjYjktZDlmYi00NjFmLThlODMtZDY2Y2NkNTdiNGY0IiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
